import React, { useReducer, useEffect, useMemo, ReactNode } from 'react';
import {
  initialState,
  settingsReducer,
  SettingsContext,
} from './SettingsContextUtils';
import { setCurrentLanguage } from 'helpers/Utils';

interface SettingsProviderProps {
  children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(settingsReducer, undefined, initialState);

  useEffect(() => {
    setCurrentLanguage(state.locale);
  }, [state.locale]);

  const contextValue = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
};
